import { Button, Stack } from "@schaeffler-commerce/design-system";
import { StepHeader } from "./StepHeader";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import type { OnboardingFormValues } from "./useOnboardingForm";

interface Props {
  onStartBrowsing: () => Promise<void> | null;
  loading: boolean;
}

export const OnboardingCompleted = ({ onStartBrowsing, loading }: Props) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<OnboardingFormValues>();

  const firstName = watch("firstName");
  return (
    <Stack
      sx={{
        gap: 4,
        alignItems: "center",
      }}
    >
      <Stack
        sx={{
          gap: 2,
        }}
      >
        <StepHeader
          title={t("onboarding.overlay.completed.title", {
            name: firstName,
          })}
          subtitle={t("onboarding.overlay.completed.subtitle")}
        />
      </Stack>
      <Button loading={loading} onClick={() => void onStartBrowsing()}>
        {t("onboarding.overlay.completed.startBrowsing")}
      </Button>
    </Stack>
  );
};
